import React, { useState, useContext } from 'react';
import DashboardContext from '../../Contexts/DashboardContext';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import LayersIcon from '@material-ui/icons/Layers';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import GavelIcon from '@material-ui/icons/Gavel';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import AuctionsTable from './Dashboard';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Chart from '../Chart/Chart';
import clsx from 'clsx';


const useStyles = makeStyles((theme) => ({
    hover: {
        '&:hover': {
            background: '#15616d',
        }
    },

    listItemText: {
        color: '#ffecd1'
    },

    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },

    fixedHeight: {
        height: 240,
    },

    disabledButton: {
        textTransform: 'capitalize',
        color: 'grey',
        '&:hover': {
            cursor: 'default',
        },
        '&:focus':{
            outline: 'none'
        }
    },
}));

const SecondaryListItems = () => {
    const classes = useStyles();
// Deconstruct needed context parameters 
const { setDisplayAuctionsTable } = useContext(DashboardContext);

const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    return (
        <>
            <ListSubheader  style={{color: '#ffecd1'}} inset>Auction overview</ListSubheader>
            <div className={classes.hover}>
                <ListItem button>
                    <ListItemIcon>
                        <AssignmentIcon style={{color: '#ffecd1'}} primary="Dashboard"  />
                    </ListItemIcon>
                    <ListItemText style={{color: '#ffecd1'}} primary="Dashboard"  primary="Current month" 
                    onClick={() => setDisplayAuctionsTable( <Paper className={fixedHeightPaper}><Chart/></Paper>)}/>
                </ListItem>
            </div>
                

            <div className={classes.hover}>
                <ListItem button>
                    <ListItemIcon>
                        <AssignmentIcon style={{color: '#ffecd1'}} primary="Dashboard"  />
                    </ListItemIcon>
                    <ListItemText style={{color: '#ffecd1'}} primary="Dashboard"  primary="Last quarter" 
                    onClick={() => setDisplayAuctionsTable( <Paper className={fixedHeightPaper}><Chart/></Paper>)}/>
                </ListItem>
            </div>
                

            <div >
                <ListItem button className={classes.disabledButton}>
                    <ListItemIcon>
                        <AssignmentIcon style={{color: 'grey'}} primary="Dashboard"  />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard"  primary="Year-end" />
                </ListItem>
            </div>
        </>
        )
};

export default SecondaryListItems;